import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import camelCaseKeys from 'utils/camelCaseKeys'
import {
  set as setSearch
} from 'store/redux/search'

export default function * fetchSearchBoards (action) {
  const { refresh, limit } = action.payload

  if (refresh) {
    yield put(setSearch({
      boards: [],
      boardsCursor: null,
      boardsTotalCount: null,
      boardsLoadedAll: false,
      boardsLoading: true
    }))
  } else {
    yield put(setSearch({
      boardsLoading: true
    }))
  }

  const state = yield select()

  const { query, refiners, boards, boardsCursor, boardsSort } = state.kanbo.search

  try {
    const { Results, Cursor, Refiners, SortOptions, TotalRows } = yield call(apiGetData, 'SearchBoards', {
      query,
      cursor: boardsCursor,
      limit,
      sort: boardsSort,
      refiners: Object.keys(refiners.boards).map(key => ({
        id: key,
        ...refiners.boards[key]
      })),
    })

    yield put(setSearch({
      boards: [
        ...boards,
        ...Results.map(Board => ({
          id: Board.Id,
          name: Board.Name,
          background: Board.Background,
          isClosed: Board.IsClosed,
          isLocked: Board.IsLocked,
          isObserved: Board.IsObserved,
          isPublic: Board.IsPublic,
          isTemplate: Board.IsTemplate,
        }))
      ],
      boardsCursor: Cursor,
      boardsRefiners: Refiners ? camelCaseKeys(Refiners) : [],
      boardsSortOptions: SortOptions ? camelCaseKeys(SortOptions) : [],
      boardsTotalCount: TotalRows,
      boardsLoadedAll: !Cursor,
      boardsLoading: false
    }))
  } catch (error) {
    yield put(setSearch({
      boardsLoading: false
    }))

    throw error
  }
}
